import type { TFunction } from 'i18next'

/**
 * Hodisa USULI — "qanaqa yo'l bilan o'tdi" degan savolga javob.
 *
 * <h2>Nega bu alohida fayl va nega umuman bor</h2>
 * Jadvalda xom `minor` ni ko'rsatish (75, 38, 76) operatorga hech narsa
 * demaydi — bu qurilma ishlab chiqaruvchisining ichki kodi. Sahifani
 * ochadigan odam esa aynan shu savol bilan keladi: xodim yuz bilan
 * o'tdimi, barmoq izi bilanmi, yoki umuman tanilmadimi.
 *
 * <h2>⚠️ RO'YXATDA FAQAT HAQIQIY QURILMADA O'LCHANGAN KODLAR BOR</h2>
 * Manba — `DeviceEventRecord.classify` Javadoc'i (2026-08-11,
 * DS-K1T343MFWX, proshivka V4.38.0):
 *
 * <pre>
 *   75 — yuz tanildi          (`employeeNoString` BOR)
 *   76 — yuz tanilmadi        (`employeeNoString` YO'Q — begona odam)
 *   38 — barmoq izi tanildi   (`employeeNoString` BOR)
 *   21 — eshik ochildi        (xodimsiz)
 *   22 — eshik yopildi        (xodimsiz)
 * </pre>
 *
 * <h2>⚠️ KARTA KODI ATAYLAB YO'Q</h2>
 * Hikvision hujjatlarida karta bilan o'tish `minor=1` deb yozilgan, lekin
 * u BU qurilmada o'lchanmagan. Hujjatdan ko'chirib qo'yish taxmin bo'lardi
 * — va aynan shu taxmin backendda ham RAD ETILGAN (o'sha Javadoc'ning
 * "OCHIQ KAMCHILIK" bo'limi). Panel serverdan oldinga o'tib ketmasligi
 * kerak: agar bu yerda "1 = Karta" deb yozilsa va qurilmada `1` boshqa
 * narsani anglatsa, jadval ishonch bilan noto'g'ri gapirardi. Hozircha
 * u `OTHER` bo'lib, xom kodi bilan ko'rinadi — ya'ni karta sinalgan kuni
 * uni jadvalda TOPISH mumkin bo'ladi.
 *
 * <h2>Nega `verifyMode` asosiy manba EMAS</h2>
 * Qurilma `currentVerifyMode` ni ham beradi, lekin u har yozuvda
 * BO'LMAYDI: o'lchangan javobda `minor=22` yozuvida u umuman yo'q edi.
 * `minor` esa har doim bor (bu proshivkada uni so'rovda ham tashlab
 * bo'lmaydi — `MessageParametersLack` qaytadi). Shuning uchun asosiy
 * manba `minor`, `verifyMode` esa qo'shimcha tafsilot bo'lib tooltip'da
 * qoladi — u yo'qolmaydi, lekin ustunni bo'sh ham qoldirmaydi.
 */
export const VERIFY_METHOD_BY_MINOR: Readonly<Record<number, string>> = {
  75: 'face',
  76: 'faceUnknown',
  38: 'fingerprint',
  21: 'doorOpen',
  22: 'doorClose',
}

/**
 * Usulning odam o'qiydigan nomi.
 *
 * ⚠️ NOMA'LUM KOD YASHIRILMAYDI, XOM HOLDA CHIQADI: "Noma'lum (kod 12)".
 * Bo'sh katak yoki "—" ma'lumot yo'qdek ko'rinardi, holbuki ma'lumot BOR
 * — biz uni hali nomlamaganmiz. Xom kod ekranda tursa, u qidiriladi va
 * ro'yxatga qo'shiladi; bo'sh katak esa hech qachon hech kimni
 * qiziqtirmaydi.
 */
export function verifyMethodLabel(minor: number | null, t: TFunction): string {
  if (minor === null) return t('attendance.event.methodUnknownNoCode')
  const key = VERIFY_METHOD_BY_MINOR[minor]
  if (key === undefined) return t('attendance.event.methodUnknown', { code: minor })
  return t(`attendance.event.method.${key}`)
}
